type Listener<T> = (payload: T) => void;
export class Emitter<TEvents extends Record<string, unknown>> {
  private readonly listeners: {
    [K in keyof TEvents]?: Set<Listener<TEvents[K]>>;
  } = {};
  on<K extends keyof TEvents>(
    name: K,
    listener: Listener<TEvents[K]>,
  ): () => void {
    let set = this.listeners[name];
    if (!set) {
      set = new Set<Listener<TEvents[K]>>();
      this.listeners[name] = set;
    }
    set.add(listener);
    return () => this.off(name, listener);
  }
  off<K extends keyof TEvents>(name: K, listener: Listener<TEvents[K]>): void {
    this.listeners[name]?.delete(listener);
  }
  emit<K extends keyof TEvents>(name: K, payload: TEvents[K]): void {
    const set = this.listeners[name];
    if (!set) {
      return;
    }
    for (const listener of Array.from(set)) {
      listener(payload);
    }
  }
  clear(): void {
    for (const key of Object.keys(this.listeners) as (keyof TEvents)[]) {
      this.listeners[key]?.clear();
    }
  }
}
